/* eslint-disable no-undef */
// @ts-nocheck
import { Base } from '@studiometa/js-toolkit';
import { Loader } from '@googlemaps/js-api-loader';

/**
 * MapBasic component
 */
export default class MapBasic extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'MapBasic',
    options: {
      zoom: {
        type: Number,
        default: 10,
      },
      items: {
        type: Array,
        default: () => [],
      },
      apiKey: {
        type: String,
        default: '',
      },
    },
    refs: ['view'],
  };

  load = null;

  map = null;

  markers = [];

  infos = [];

  /** @inheritdoc */
  mounted() {
    this.loader = new Loader({
      apiKey: this.$options.apiKey || '',
      version: 'weekly',
      libraries: ['places'],
    });

    this.loader
      .load()
      .then((google) => {
        this.map = new google.maps.Map(this.$refs.view, {
          center: {
            lat: 0,
            lng: 0,
          },
          zoom: 4,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          panControl: false,
          styles: [
            {
              featureType: 'all',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  saturation: 36,
                },
                {
                  color: '#000000',
                },
                {
                  lightness: 40,
                },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  visibility: 'on',
                },
                {
                  color: '#000000',
                },
                {
                  lightness: 16,
                },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.icon',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 20,
                },
              ],
            },
            {
              featureType: 'administrative',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 17,
                },
                {
                  weight: 1.2,
                },
              ],
            },
            {
              featureType: 'administrative',
              elementType: 'labels',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.country',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'simplified',
                },
              ],
            },
            {
              featureType: 'administrative.country',
              elementType: 'geometry',
              stylers: [
                {
                  visibility: 'simplified',
                },
              ],
            },
            {
              featureType: 'administrative.country',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'simplified',
                },
              ],
            },
            {
              featureType: 'administrative.province',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.locality',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'simplified',
                },
                {
                  saturation: '-100',
                },
                {
                  lightness: '30',
                },
              ],
            },
            {
              featureType: 'administrative.neighborhood',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'landscape',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'simplified',
                },
                {
                  gamma: '0.00',
                },
                {
                  lightness: '74',
                },
              ],
            },
            {
              featureType: 'landscape',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 20,
                },
              ],
            },
            {
              featureType: 'landscape.man_made',
              elementType: 'all',
              stylers: [
                {
                  lightness: '3',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 21,
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [
                {
                  visibility: 'simplified',
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 17,
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 29,
                },
                {
                  weight: 0.2,
                },
              ],
            },
            {
              featureType: 'road.arterial',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 18,
                },
              ],
            },
            {
              featureType: 'road.local',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 16,
                },
              ],
            },
            {
              featureType: 'transit',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 19,
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#000000',
                },
                {
                  lightness: 17,
                },
              ],
            },
          ],
        });

        this.ready();
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e);
      });
  }

  /**
   * Google Maps Ready
   */
  ready() {
    const bounds = new google.maps.LatLngBounds();

    this.$options.items.forEach((office) => {
      const service = new google.maps.places.PlacesService(this.map);

      service.findPlaceFromQuery(
        {
          query: office.address,
          fields: ['name', 'geometry'],
        },
        (results, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK) {
            return;
          }

          const result = results?.[0] || null;

          if (!result) {
            return;
          }

          // Create marker
          const marker = new google.maps.Marker({
            position: new google.maps.LatLng(
              result.geometry.location.lat(),
              result.geometry.location.lng()
            ),
            title: office.title,
            icon: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='41' viewBox='0 0 32 41'%3E%3Cpath fill='%23E30613' d='M16 0C11.7581 0.00500432 7.69133 1.69232 4.69183 4.69181C1.69234 7.69131 0.00502134 11.7581 1.70224e-05 16C-0.00506354 19.4665 1.12726 22.8389 3.22329 25.6C3.22329 25.6 3.65965 26.1745 3.73092 26.2574L16 40.7272L28.2749 26.2502C28.3389 26.1731 28.7767 25.6 28.7767 25.6L28.7782 25.5956C30.8732 22.8358 32.005 19.4649 32 16C31.995 11.7581 30.3077 7.69131 27.3082 4.69181C24.3087 1.69232 20.2419 0.00500432 16 0ZM16 21.8182C14.8493 21.8182 13.7244 21.4769 12.7676 20.8376C11.8108 20.1983 11.0651 19.2896 10.6247 18.2265C10.1843 17.1634 10.0691 15.9935 10.2936 14.8649C10.5181 13.7363 11.0722 12.6996 11.8859 11.8859C12.6996 11.0722 13.7363 10.5181 14.8649 10.2936C15.9935 10.0691 17.1634 10.1843 18.2265 10.6247C19.2897 11.0651 20.1983 11.8108 20.8376 12.7676C21.4769 13.7244 21.8182 14.8493 21.8182 16C21.8163 17.5425 21.2026 19.0212 20.1119 20.1119C19.0212 21.2026 17.5425 21.8162 16 21.8182Z'/%3E%3C/svg%3E`,
          });
          // Add marker to Google Maps
          marker.setMap(this.map);
          // Add marker to current component
          this.markers.push(marker);
          // Add marker to bound
          bounds.extend(marker.getPosition());

          // Create info
          const info = new google.maps.InfoWindow({
            content: `
            <div class="google-maps__info">
              <h2 class="font-matter font-medium text-base text-black leading-8">
                ${office.title}
              </h2>
              <div class="mt-1 mb-5 font-normal font-matter text-s text-grey-80 leading-5">
                ${office.address}
              </div>
              <div>
                <a href="http://maps.google.com/maps?daddr=${office.address}" target="_blank" class="link || font-matter font-normal text-base">
                  Itinéraire
                </a>
              </div>
            </div>
            `,
          });

          // Add info to component
          this.infos.push(info);

          // Opens info when you click on a marker
          marker.addListener('click', () => {
            this.infos.forEach((item) => item.close());

            info.open({
              anchor: marker,
              map: this.map,
              shouldFocus: false,
            });
          });

          if (this.markers.length === this.$options.items.length) {
            this.map.fitBounds(bounds);
          } else {
            this.map.setCenter(result.geometry.location);
          }
        }
      );
    });
  }
}
